import React, {useState} from "react";
import {Button, Modal, notification} from "antd";
import {ExclamationCircleFilled} from "@ant-design/icons";
import SharedService from "../../../services/shared/service";
import {pluralize} from "../../../utils/string.utils";

const BulkDeleteInvoiceModal = ({visible, onCancel, documentIds = [], user}) => {
    const [loading, setLoading] = useState(false);

    const deleteInvoice = async () => {
        try {
            setLoading(true);
            await SharedService.post({
                token: user.token,
                url: "documents/delete",
                data: documentIds,
            });
            onCancel?.();
            window.location.reload();
        } catch (error) {
            console.error("Bulk delete failed:", error);
            notification.error({
                message: `Failed to delete ${pluralize(documentIds, "invoice")}`,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={`Delete ${pluralize(documentIds, "invoice")}`}
            open={visible}
            onCancel={onCancel}
            closable={true}
            width={460}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    danger
                    loading={loading}
                    onClick={deleteInvoice}
                >
                    Delete
                </Button>,
            ]}
        >
            <div className="flex items-start gap-3">
                <ExclamationCircleFilled
                    style={{color: "#A4231D", fontSize: 22, marginTop: 2, flexShrink: 0}}
                />
                <div>
                    <div className="text-[14px] text-[#0B1220] font-medium">
                        Are you sure you want to delete {pluralize(documentIds, "invoice").toLowerCase()}?
                    </div>
                    <div className="text-[12.5px] text-[#7A849A] mt-1">
                        This action cannot be undone.
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BulkDeleteInvoiceModal;
